import * as React from "react";
import { gql, useQuery } from "@apollo/client";

import {
  FindCommunitiesFromCampaignsQuery,
  Community
} from "../../../../../schemaTypes";

export const findCommunitiesFromCampaignsQuery = gql`
  query FindCommunitiesFromCampaigns {
    findCommunitiesFromCampaigns {
      id
      name
      alias
    }
  }
`;

export const newCampaignSubscription = gql`
  subscription NewCampaignSubscription {
    newCampaign {
      id
      title
      location
      community
    }
  }
`;

type NewCampaignSubscriptionResult = {
  newCampaign: Community;
};

export function useSubscribeToNewCommunitiesFromCampaigns(subscribeToMore: any) {
  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newCampaignSubscription,
      updateQuery: (prev: any, { subscriptionData }: { subscriptionData: { data?: NewCampaignSubscriptionResult } }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          findCommunitiesFromCampaigns: [
            ...prev.findCommunitiesFromCampaigns,
            subscriptionData.data.newCampaign
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);
}

export function useFindCommunitiesFromCampaigns() {
  const { data, loading, subscribeToMore } = useQuery<FindCommunitiesFromCampaignsQuery>(findCommunitiesFromCampaignsQuery);

  useSubscribeToNewCommunitiesFromCampaigns(subscribeToMore);

  return {
    communities: data?.findCommunitiesFromCampaigns ?? [],
    loading
  };
}
